import { buildEndpointUrl } from '@/_shared/helpers/makeSwaggerToEndpointUrl';
import {
  API_ORGANIZATIONS_ORGANIZATIONID_SUBSCRIPTIONS_BILLING_LINK_PATH_KEY,
  API_ORGANIZATIONS_ORGANIZATIONID_SUBSCRIPTIONS_PATH_KEY,
} from '@/swagger/constants/slash-keys';

export const API_GET_SUBSCRIPTION = (org: string) => {
  return buildEndpointUrl(API_ORGANIZATIONS_ORGANIZATIONID_SUBSCRIPTIONS_PATH_KEY, {
    organizationId: org,
  });
};

export const API_GET_BILLING_LINK = (org: string) => {
  return buildEndpointUrl(API_ORGANIZATIONS_ORGANIZATIONID_SUBSCRIPTIONS_BILLING_LINK_PATH_KEY, {
    organizationId: org,
  });
};
